import { useQuery } from "@tanstack/react-query";
import type { DelayByShift } from "../../delays-manager/models/DelayByShift";
import { getDelaysByShift } from "../../delays-manager/repositories/DelaysManagerRepository";

export const useDelaysByShiftQuery = (
  shiftId: number,
  delayAreaAssetId: number | null,
  microDelays: boolean,
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: ["delays-by-shift", shiftId, delayAreaAssetId, microDelays],
    meta: { realtime: ["DEL.GetDelaysByShift"] },
    queryFn: async ({ signal }) => {
      const resp = await getDelaysByShift({
        shiftId,
        delayAreaAssetId,
        microDelays,
        signal,
      });
      if (resp.ok) {
        return resp.data as DelayByShift[];
      }
      throw new Error(resp.message ?? "Failed to fetch delays");
    },
    enabled: shiftId != null && shiftId > 0,
    onError,
  });
};
